import { render, staticRenderFns } from "./AddDrugAlcoholTest.vue?vue&type=template&id=9f059330&scoped=true&"
import script from "./AddDrugAlcoholTest.vue?vue&type=script&lang=js&"
export * from "./AddDrugAlcoholTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f059330",
  null
  
)

export default component.exports